<div class="checkout-header container-fluid" [ngClass]="{ siteHeader__small: smallHeader }">
  <div class="row">
    <div class="col d-flex justify-content-center mb-md-11 mb-9">
      <div class="siteHeader__logo">
        <a [routerLink]="{ cxRoute: 'home' } | cxUrl" class="siteHeader__logo__logo"></a>
      </div>
    </div>
  </div>

  <div *ngIf="!smallHeader" class="row">
    <div class="col">
      <app-checkout-progress *ngIf="!isCheckoutLogin"></app-checkout-progress>

      <div class="checkout-infobar-container">
        <div class="checkout-infobar">
          <div *ngFor="let item of infobarTexts" class="checkout-info">
            <app-svg [iconName]="'check'" dimension="1.5rem"></app-svg>
            <span class="d-inline-block">{{ item.text | cxTranslate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col p-0">
      <app-global-message></app-global-message>
    </div>
  </div>
</div>
